export default __webpack_public_path__ + "static/media/proxima-nova-regular.2a9ce1ea.ttf";